import { useLayoutEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";

// project import
// import useAuth from "hooks/useAuth";
import Loader from "components/Loader";


// types
import { GuardProps } from "types/auth";
// import { createToken, encrypt } from "utils/commonFunctions";
import { createToken, decrypt, encrypt, getDomainName, setEncryptedItem } from "utils/commonFunctions";
import Unauthorized from "pages/maintenance/unautorized";

// ==============================|| AUTH GUARD ||============================== //
const domain = getDomainName();
const isIONetgateDomain = domain.includes('io-netgate');
const isIOMDomain = domain.includes('io-market');

const AuthGuard = ({ children }: GuardProps) => {
  // const { isLoggedIn } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  // const navigate = useNavigate();
  // const location = useLocation();
  const [accessGranted, setAccessGranted] = useState(false);
  const host = window.location.host;
  const parts = host.split(".");
  parts.shift();    
  const domain = parts.join('.')

  const redirectToLogin = () => {
    if (!isIONetgateDomain) {
      const profileUrl = `${process.env.REACT_APP_ACCOUNT_LOGIN}${domain}#/profile`
      window.location.assign(profileUrl);
    }
  }

  const getUserAccessRole = async () => {
    try {
      let encrDataUser = new FormData();
      if(isIOMDomain){
        let code = {"code":"COM"}
        let tokenUser = createToken(code);
        let encryptedTokenUser = encrypt(tokenUser);
        encrDataUser.append("encrToken", encryptedTokenUser); const userResp = await axios.post(`${JSON.parse(process.env.REACT_APP_AUTH_API_URL!)[domain]}userProfile`, encrDataUser, { withCredentials: true });
        return {data : userResp.data.data ,status :userResp.data.status };
      }
      else if(isIONetgateDomain){

        const cookie = JSON.parse(decrypt(Cookies.get("loginCookie")|| ""));
        let dataObj = {
          "instanceId":cookie.instanceId,
          "companyUserId": cookie.companyUserId,
          "userId":cookie.userId,
        }
        let tokenDataObj = createToken(dataObj);
        let encryptedTokenDataObj = encrypt(tokenDataObj);
        encrDataUser.append("encrToken", encryptedTokenDataObj);
        const userResp = await axios.post(`${JSON.parse(process.env.REACT_APP_AUTH_API_URL!)["io-netgate.net"]}userRights`, encrDataUser);
        return {data : userResp.data.DATA ,status :userResp.data.STATUS };
      }
    } catch (err) {
      console.error("Error in getting access role:", err);
      throw err;
    }
  };


    useLayoutEffect(() => {
      const checkAccess = async () => {
        try {
          const cookieExist = isIONetgateDomain
            ? Cookies.get(process.env.REACT_APP_INSTANCE_COOKIE || "") &&
              Cookies.get(process.env.REACT_APP_LOGIN_COOKIE || "")
            : Cookies.get(process.env.REACT_APP_EXPIRE_COOKIE || "");

          if (!cookieExist) {
            redirectToLogin();
            setIsLoading(false);
            return;
          }

          const response = await getUserAccessRole();


          if (response?.status) {
            if (isIOMDomain) {
              const allowPermissions: string[] = response?.data?.userPermissions?.Allow || [];

              const flatPermissions = allowPermissions
                .flatMap(p => p.split(","))
                .map(p => p.trim());

              const hasCompareAccess = flatPermissions.some(p =>
                p.startsWith("compare.login")
              );

              if (hasCompareAccess) {
                console.log("Compare Access allowed");
                
                const allowPermissions: string[] = response?.data?.userPermissions?.Allow || [];

                //push permissions for compare into local storage
                const comparePermissions = [
                  ...new Set(
                    allowPermissions
                      .flatMap(p => p.split(','))
                      .map(p => p.trim())
                      .filter(p => p.startsWith('compare.'))
                  )
                ];

                localStorage.setItem('userPermissions', JSON.stringify(comparePermissions));

                setAccessGranted(true);
              } else {
                console.log("Compare Access denied");
                setAccessGranted(false);
                redirectToLogin();
              }
            } else if(isIONetgateDomain){
                const filteredPermissions = response.data
                  .split(",")
                  .map((p:any) => p.trim())
                  .filter((p:any) => p.toLowerCase().includes("compare".toLowerCase()));
                localStorage.setItem(
                  "userPermissions",
                  JSON.stringify(filteredPermissions)
                );

                let instaceCookie =  JSON.parse(decrypt(Cookies.get(process.env.REACT_APP_INSTANCE_COOKIE || "")|| ""));
                if(instaceCookie){
                  const value = {dark:instaceCookie?.logo , white:instaceCookie?.logo ,instance:instaceCookie?.instance}
                  setEncryptedItem('logo',JSON.stringify(value))
                }

                setAccessGranted(true);
            } else {
              let instaceCookie =  JSON.parse(decrypt(Cookies.get(process.env.REACT_APP_INSTANCE_COOKIE || "")|| ""));
              
              if(instaceCookie){
                const value = {dark:instaceCookie?.logo , white:instaceCookie?.logo ,instance:instaceCookie?.instance}
                setEncryptedItem('logo',JSON.stringify(value))
              }
              setAccessGranted(true);
            }
          } else {
            console.log("Compare Access denied");
            setAccessGranted(false);
            redirectToLogin();
          }
        } catch (err) {
          console.error("Error in getting access role:", err);
          setAccessGranted(false);
          redirectToLogin();
        } finally {
          setIsLoading(false);
        }
      };

      checkAccess();
  }, []);

  if(isLoading){
    return <Loader />
  }
  
  return accessGranted ? children : isIONetgateDomain && <Unauthorized />
};

export default AuthGuard;
